import React, { useState, useEffect } from "react";
import Select from "react-select";
import TransactionService from "../services/TransactionService";
import ListingService from "../services/ListingService";
import { useSelector, useDispatch } from "react-redux";
import DataAccess from "../utility/DataAccess";
import SettingsService from "../services/SettingsService";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { trHeader, trHeaders } from "../i18n/headerMap";
import PopupCloseButton from "../components/PopupCloseButton";

const Insert = (props) => {
  const { t } = useTranslation();
  const [dropdownOptions, setDropdownOptions] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});
  const [inputValues, setInputValues] = useState({});

  useEffect(() => {
    var isUpdate = props.isVisible;
    if (isUpdate) {
      connectData();
    }
  }, [props.isVisible]);

  function extractDropdownPairs(data) {
    const dropdownPairs = {};
    data.value.forEach((column) => {
      if (column.type === "dropdown") {
        dropdownPairs[column.accessor] = column.sourceSelect || "";
      }
    });

    return dropdownPairs;
  }
  const getValue = (inputName) => inputValues[inputName] || "";

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setInputValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const connectData = async () => {
    var finalOptions = {};
    if (props.isVisible) {
      try {
        var pairs = extractDropdownPairs(props.selectedTable);
        SettingsService.executeSQLQueryBatch(pairs)
          .then((result) => {
            var data = result;

            for (var i = 0; i < props.selectedTable.value.length; i++) {
              var current = props.selectedTable.value[i];
              var currentData = data[current.accessor];
              var type = current.type;
              var additional = current.additional;

              if (type === "dropdown") {
                const options = currentData.map((item) => {
                  const value = current.columnOrder
                    .map((field) => item[field])
                    .join("|");
                  const properties = current.columnOrder.map(
                    (field) => item[field],
                  );
                  const names = trHeaders(
                    current.columnOrderTranslation,
                    t,
                  );
                  const widths = current.columnOrderWidth.map((field) => field);
                  return {
                    value: properties.join("|"),
                    label: properties.join("|"),
                    id: item[current.dropdownId],
                    properties,
                    names,
                    widths,
                    header: false,
                  };
                });
                var emptyOption = {
                  value: "Test",
                  label: "Test",
                  id: "",
                  properties: trHeaders(current.columnOrderTranslation, t),
                  widths: current.columnOrderWidth,
                  names: trHeaders(current.columnOrderTranslation, t),
                  header: true,
                };

                finalOptions[current.accessor] = [emptyOption, ...options];
              }
            }

            setDropdownOptions(finalOptions);
          })
          .catch((error) => {});
      } catch (error) {}
    }
  };

  const formatOptionLabel = ({ label, properties, widths, header, id }) => {
    const exists = Object.values(selectedOptions).some(
      (item) => item.id === id,
    );

    // Return the component with the processed data
    return (
      <DynamicFormatOptionLabel
        properties={properties}
        id={id}
        label={label}
        widths={widths}
        header={header}
        selected={exists}
      />
    );
  };

  const DynamicFormatOptionLabel = ({
    label,
    properties,
    widths,
    header,
    selected,
    id,
  }) => (
    <div>
      {properties && properties.length > 0 && !selected ? (
        <div style={{ display: "flex", margin: "0", padding: "0" }}>
          {properties.map((property, index) =>
            !header ? (
              <div
                key={index}
                style={{
                  minWidth: widths[index],
                  paddingLeft: "3px",
                  paddingRight: "3px",
                  fontSize: "80%",
                  color: "gray",
                  marginRight: "0px",
                  whiteSpace: "nowrap",
                }}
              >
                {property}
              </div>
            ) : (
              <div
                key={index}
                style={{
                  fontWeight: "600",
                  minWidth: widths[index],
                  paddingLeft: "5px",
                  paddingRight: "3px",
                  fontSize: "80%",
                  color: "black",
                  marginRight: "0px",
                  whiteSpace: "nowrap",
                }}
              >
                {property}
              </div>
            ),
          )}
        </div>
      ) : (
        <div style={{ fontSize: "100%" }}>{id}</div>
      )}
    </div>
  );

  if (!props.isVisible) {
    return null;
  }

  function onClose() {
    setSelectedOptions({});
    setInputValues({});
    props.onClose();
  }
  const handleSelectChange = (accessor, selected) => {
    var specificObject = dropdownOptions[accessor];
    var insertObject = specificObject.find((item) => item.id === selected.id);
    setSelectedOptions({
      ...selectedOptions,
      [accessor]: insertObject,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevents the default form submission behavior

    sendData();
  };

  function resolveDynamicQuery() {
    var counter = 0;
    var fields = "";
    var values = "";
    var foundData = [];
    const propertyCount =
      Object.keys(inputValues).length + Object.keys(selectedOptions).length;
    for (const [key, value] of Object.entries(inputValues)) {
      counter += 1;

      if (counter == 1) {
        fields += "(";
        values += "(";
      }

      if (counter == propertyCount) {
        if (!props.selectedTable.insertHasUser) {
          fields += "[" + key + "])";
          values += "@" + key + ")";
        } else {
          fields += "[" + key + "],[" + props.selectedTable.insertUserId + "])";
          values += "@" + key + "," + props.selectedTable.insertUserId + ")";
        }
      } else {
        fields += "[" + key + "],";
        values += "@" + key + ",";
      }

      foundData.push(key);
    }

    for (const [key, value] of Object.entries(selectedOptions)) {
      counter += 1;

      if (counter == 1) {
        fields += "(";
        values += "(";
      }

      if (counter == propertyCount) {
        if (!props.selectedTable.insertHasUser) {
          fields += "[" + key + "])";
          values += "@" + key + ")";
        } else {
          fields += "[" + key + "],[" + props.selectedTable.insertUserId + "])";
          values += "@" + key + ",@" + props.selectedTable.insertUserId + ")";
        }
      } else {
        fields += "[" + key + "],";
        values += "@" + key + ",";
      }

      foundData.push(key);
    }

    return [fields, values, foundData];
  }

  const sendData = () => {
    var dynamic = resolveDynamicQuery();
    var insertQuery = props.selectedTable.insertQuery;

    insertQuery = insertQuery.replace("(#fields)", dynamic[0]);
    insertQuery = insertQuery.replace("(#parameters)", dynamic[1]);

    var columns = props.selectedTable.value;
    var params = [];

    for (let i = 0; i < columns.length; i++) {
      var column = columns[i];
      var type = column.type;
      var accessor = column.accessor;

      if (type != "nothing" && dynamic[2].includes(accessor)) {
        var column = columns[i];
        var type = column.type;
        var accessor = column.accessor;
        var dbType = column.dbType;
        if (type !== "nothing") {
          var theValue = "";
          if (type == "text") {
            theValue = getValue(accessor);
          } else if (type == "dropdown") {
            theValue = selectedOptions[accessor]?.id || "";
          } else if (type == "checkbox") {
            theValue = selectedOptions[accessor] || false;
          } else if (type == "number") {
            theValue = getValue(accessor);
          }

          var converted = {};
          if (dbType == "Int64") {
            converted = Number(theValue);
          } else if (dbType == "String") {
            converted = theValue;
          } else if (dbType == "Boolean") {
            if (theValue == "") {
              converted = false;
            }
          }

          var parameter = { Name: accessor, Type: dbType, Value: converted };

          params.push(parameter);
        }
      }
    }

    const userId = localStorage.getItem("name");
    const userIdAsInt = parseInt(userId, 10);

    var parameterUser = {
      Name: props.selectedTable.insertUserId,
      Type: "Int64",
      Value: userIdAsInt,
    };

    params.push(parameterUser);
    SettingsService.insertSQLQuery(insertQuery, params).then((result) => {
      props.refresh();
      var data = result;

      if (data) {
        try {
          const keyField = props?.selectedTable?.id;
          if (keyField) {
            const col = props?.selectedTable?.value?.find(
              (c) => c && c.accessor === keyField,
            );
            let createdKey = null;
            if (col?.type === "dropdown") {
              createdKey = selectedOptions[keyField]?.id ?? null;
            } else if (col?.type === "checkbox") {
              createdKey = selectedOptions[keyField] ?? null;
            } else {
              createdKey = getValue(keyField) ?? null;
            }
            if (createdKey != null && createdKey !== "") {
              props.onInserted?.({ key: createdKey });
            } else {
              props.onInserted?.({ key: null });
            }
          } else {
            props.onInserted?.({ key: null });
          }
        } catch {
          props.onInserted?.({ key: null });
        }
        onClose();
      } else {
        Swal.fire("Napaka!", "Zapis ni bil zapisan.", "error");
        onClose();
      }
    });
  };

  return (
    <div className="popup-overlay insert">
      <div className="popup-content insert wms-popup-shell wms-settings-form-popup">
        <div className="popup-header insert wms-popup-header">
          <PopupCloseButton onClick={onClose} />
        </div>
        <form className="form-insert" onSubmit={handleSubmit}>
          <div className="popup-body insert">
            {props.selectedTable.value.map(
              (column) =>
                column.type !== "nothing" && (
                  <div
                    key={column.accessor}
                    className={
                      column.type === "checkbox"
                        ? "form-group insert wms-settings-row-checkbox"
                        : "form-group insert"
                    }
                  >
                    <label
                      className="wms-settings-field-label"
                      htmlFor={column.accessor}
                    >
                      <span className="wms-settings-field-label-text">
                        {typeof column.Header === "string"
                          ? trHeader(column.Header, t)
                          : column.Header}
                      </span>
                    </label>
                    {column.type === "dropdown" ? (
                      <div className="wms-settings-select">
                        <Select
                          id={column.accessor}
                          placeholder={column.dropdownPlaceholder}
                          name={column.accessor}
                          getOptionLabel={(option) => option.label}
                          getOptionValue={(option) => option.value}
                          formatOptionLabel={formatOptionLabel}
                          options={dropdownOptions[column.accessor] || []}
                          value={selectedOptions[column.accessor]}
                          onChange={(selected) =>
                            handleSelectChange(column.accessor, selected)
                          }
                          required={column.required}
                        />
                      </div>
                    ) : (
                      <input
                        type={
                          column.type === "checkbox"
                            ? "checkbox"
                            : column.type === "number"
                              ? "number"
                              : "text"
                        }
                        id={column.accessor}
                        maxLength={column.max}
                        required={
                          column.type === "checkbox" ? false : column.required
                        }
                        name={column.accessor}
                        className={
                          column.type === "checkbox"
                            ? "form-check-input"
                            : "form-control"
                        }
                        value={getValue(column.accessor)} // Set the value from state
                        onChange={handleInputChange} // Update the state on change
                      />
                    )}
                  </div>
                ),
            )}
          </div>

          <div className="wms-popup-footer-actions wms-settings-form-footer">
            <button type="submit" className="actions smallerr">
              {t("common.add")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Insert;
